import { graphql, StaticQuery } from "gatsby"
import React from "react"
import ProductCards from "./ProductCards"

export default function OtherDesignSection({ oldId }) {
  return (
    <section>
      <p className="h5 font-weight-bold">Orang lain juga beli</p>
      <StaticQuery
        query={graphql`
          query otherDesign {
            allMarkdownRemark(limit: 5) {
              edges {
                node {
                  frontmatter {
                    image
                    onSale
                    price
                    slug
                    title
                  }
                  id
                }
              }
            }
          }
        `}
        render={({ allMarkdownRemark: { edges: products } }) => {
          let filteredProducts = products.filter(
            product => product.node.id != oldId
          )
          return <ProductCards products={filteredProducts} />
        }}
      />
    </section>
  )
}
